import AdministrationState from './Types';

import { AdministrationActionTypes, AdministrationActions } from './actions';

const initialState: AdministrationState = {
    tenantCompanies: [],
    tenantCompaniesLoaded: false,
};

export default function administrationReducer(
    state: AdministrationState = initialState,
    action: AdministrationActionTypes,
): AdministrationState {
    switch (action.type) {
        case AdministrationActions.SET_TENANT_COMPANIES:
            return {
                ...state,
                tenantCompanies: [...action.payload],
                tenantCompaniesLoaded: true,
            };
        default:
            return {
                ...state,
            };
    }
}
